module.exports = __webpack_public_path__ + "img/card_5.a7c92e6c.png";